module.exports = __webpack_public_path__ + "img/bottle_medium.695638ed.png";